import { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { notification } from "antd";
// REDUX
import { useSelector } from "react-redux";
import { usePutAdapterMutation } from "../../redux/adapters/adapterAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { RootState } from "../../app/store";
import { AdapterInterface } from "../../interfaces/Adapter.interface";

export default function usePutAdapter() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme, userLogged } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [trigger, { isLoading, isSuccess, isError }] = usePutAdapterMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const putAdapter = async (adapter: AdapterInterface) => {
    const token = await GETJwtToken();
    const body = {
      ...adapter,
      bacnet_config: null,
    };
    delete (body as any).bacnet_bank_mappings;
    trigger({ id: adapter.id, token, body });
  };

  const launchSuccessNotification = () => {
    if (userLogged.command_notifications) {
      notification.success({
        message: "Success",
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }
  };

  const launchErrorNotification = () => {
    if (userLogged.command_notifications) {
      notification.error({
        message: "Error",
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    if (isSuccess) {
      launchSuccessNotification();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      launchErrorNotification();
    }
  }, [isError]);

  // ************************************************ */
  // COMPONENT ************************************** */

  return {
    putAdapter,
    isLoadingPutAdapter: isLoading,
    isErrorPutAdapter: isError,
    isSuccessPutAdapter: isSuccess,
  };
}
